import React from 'react'; 
import classes from './Timings.scss';

const timings = (props) => (
    <div className={classes.Timings}>
        {props.children}
    </div>
);

export default timings;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Mobile/Tuple/Timings/Timings.js